export default __webpack_public_path__ + "static/compare-title-57a9e8e9137b5bfe27aff2bed4a362cf.png";